module.exports = __webpack_public_path__ + "img/Wong.1a0048f4.jpeg";